const FormResources = {

    form_data:{
        name: '',
        code: '',
        memo: '',
    },

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  60,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Step:',
            model_name: 'code',
            ref:        'code_input',
            ref_alt:    'code_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12',
            type:       'textarea',
            maxlength:  600,
            disabled:   false,
            step:       '',
            name:       'Memo:',
            model_name: 'memo',
            ref:        'memo_input',
            ref_alt:    'memo_input_alt',
            required:   false,
        }
    ]

}

export default FormResources;